import React, { useState, useEffect } from "react";
import { styled } from "../stitches.config";
import { Comments } from "react-facebook";
import { observer } from "mobx-react";
import { CSSTransition } from "react-transition-group";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { StickyContainer, Sticky } from "react-sticky";

import { IS_FEATURE_enableComments } from "./common/constants/constants";

import { h3 } from "../redesign/commonStyles/Fonts";

import { useStores } from "../helpers/useStores";
import Header from "./Article/Header";
import Payment from "./Article/Parts/Brid/BridPaymentModal/BridPayment";
import BridDonate from "./Article/BridDonate";
import BridDonationProgress from "./Article/BridDonationProgress";
import BridCompletedProjects from "./Article/Parts/Brid/BridCompletedProjects";
import BridImageBanner from "./Article/Parts/Brid/BridImageBanner";
import AnimateHeightWrapper from "./Article/Parts/Brid/common/components/AnimateHeightWrapper";
import * as S from "./Article/Parts/Brid/common/styles/Styles";
import { useWindowWidth, pushDataLayer } from "../helpers";
import ContentHider from "../helpers/ContentHider";
import Adslot from "./Adslot";
import { useLocation } from "react-router-dom";
import { useThemeContext } from "../redesign/components/StitchesThemeProvider";

export const DONATE_VALUES: Array<string> = [
  "5",
  "10",
  //   "20",
  "50",
  "100",
  //   "200",
  "own",
];

export interface IFormValues {
  email: string;
  paymentMethod: string;
  newsletter: boolean;
  dataProcessing: boolean;
  name: string;
  donateAmount: string;
  donateCustomAmount: string;
}

const ArticleBrid: React.FC<any> = observer((props) => {
  const location = useLocation();
  const isDesktop = window.innerWidth >= 996;
  const { ArticleStore } = useStores();
  const width = useWindowWidth();
  const initialDonationValue: string = location.state?.fromSG
    ? DONATE_VALUES[6]
    : DONATE_VALUES[2]; //jeżeli z SG - kwota dowolna
  const [showModal, setShowModal] = useState<boolean>(false);
  const [waiting, setWaiting] = useState<boolean>(false);
  const [values, setValues] = useState<IFormValues | null>(null);
  const initialValues: IFormValues = {
    email: "",
    paymentMethod: "przelewy24",
    newsletter: false,
    dataProcessing: false,
    donateAmount: initialDonationValue,
    name: "",
    donateCustomAmount: "",
  };
  const bridStatus = window?.APP_SETTINGS?.bridStatus || {};

  useEffect(() => {
    if (
      location.state?.fromSG &&
      !ArticleStore.article.brid_donation_progress.finished
    ) {
      setShowModal(true);
    }
  }, []);

  useEffect(() => {
    if (waiting && values) {
      handlePayment(values);
    }
  }, [waiting, values]);

  const handleSubmit = (values: IFormValues) => {
    setWaiting(true);
    setValues(values);
  };

  const handlePayment = (values: IFormValues) => {
    const fd = new FormData();
    const donateAmount =
      values.donateAmount === "own"
        ? values.donateCustomAmount
        : values.donateAmount;
    fd.append("email", values.email);
    fd.append("name", values.name);
    fd.append("amount", donateAmount);
    fd.append("newsletter", `${+values.newsletter}`);
    fd.append("regulamin", `${+values.dataProcessing}`);
    fd.append("articleId", ArticleStore.article.OID);

    // window.gtag('event', 'Pay', {
    //     event_category: 'BRID',
    //     event_label: window.location.pathname
    // })

    pushDataLayer({
      event: "analyticsEvent",
      eventCategory: "BRID",
      eventAction: "Modal pay",
      eventLabel: window.location.pathname,
      eventValue: undefined,
      eventCallback: function () {
        return fetch(`${window.API_HOST}/pwa-brid-payment/`, {
          method: "POST",
          body: fd,
        })
          .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
          .then((res) => {
            // console.log(res.data)
            window.open(res.data.trnUrl, "_self");
          })
          .catch((err) => console.log(err));
      },
      eventTimeout: 2000,
    });
  };

  const payForm = () => (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        name: Yup.string()
          .min(2, "Za krótkie")
          .max(50, "Za długie")
          .required("Pole wymagane"),
        email: Yup.string()
          .email("Niepoprawny adres email")
          .required("Pole wymagane"),
        newsletter: Yup.boolean()
          .required("Pole wygmagane")
          .oneOf([true], "Musisz zaakceptować warunki."),
        dataProcessing: Yup.boolean()
          .required("Pole wymagane")
          .oneOf([true], "Musisz zaakceptować warunki."),
        donateAmount: Yup.mixed().required(),
        donateCustomAmount: Yup.number().when("donateAmount", {
          is: (value : any) => value === "own",
          then: (schema) => schema
            .required("Pole wymagane")
            .transform((_, value) => {
              return +value.replace(/,/, ".");
            })
            .positive("Wartość musi być dodatnia")
            .moreThan(0)
            .lessThan(100000)
            .test("isDecimal", "Wartość po przecinku", (value : number) =>
              /^\d{0,5}(\.\d{1,2})?$/.test(value.toString())
            ),
          otherwise: (schema) => schema
        }),
      })}
      onSubmit={(values) => handleSubmit(values)}
    >
      {(props) => (
        <React.Fragment>
          {/* {ArticleStore.article.brid_donation_progress.finished ? (
          <>
            {width > 992 && (
              <StickyContainer
                style={{ marginTop: -70, height: "100%" }}
              >
                <Sticky topOffset={-180}>
                  {({ style, isSticky }: any) => (
                    <StickyWrap isSticky={isSticky} style={style}>
                      <Adslot name="Brid_halfpage" />
                    </StickyWrap>
                  )}
                </Sticky>
              </StickyContainer>
            )}
          </>
        ) : ( */}
          <Form>
            {/* {width > 992 && (
                <StickyContainer style={{ marginTop: -70, height: "inherit" }}>
                  <Sticky topOffset={-180}>
                    {({ style, isSticky }: any) => (
                      <StickyWrap isSticky={isSticky} style={style}> */}
            <BridDonate setShowModal={setShowModal} {...props} />
            {/* </StickyWrap>
                     )}
                   </Sticky>
                 </StickyContainer>
            )} */}
            <CSSTransition
              in={showModal || bridStatus.paymentSuccess}
              timeout={400}
              classNames="modal"
              mountOnEnter
              unmountOnExit
            >
              <Payment
                key="modal"
                setShowModal={setShowModal}
                waiting={waiting}
                payForm={payForm}
                {...props}
              />
            </CSSTransition>
          </Form>
          {/* )} */}
        </React.Fragment>
      )}
    </Formik>
  );

  const { isDarkMode } = useThemeContext();

  return (
    <div>
      <BridImageBanner blockData={ArticleStore.article.TitlePart[0]?.data} />
      <BridBackgroundWrapper className="brid-background-wrapper" isDarkTheme={isDarkMode}>
        <BridArticle>
          <ColumnLeft className={!isDesktop ? "container" : ""}>
            <Header article={ArticleStore.article} />
            {IS_FEATURE_enableComments &&
              <ContentHider height={200}>
                <CommentsWrapper className="brid-comments-wrapper">
                  <h3 className={h3()}>Komentarze</h3>
                  <AnimateHeightWrapper height={250}>
                    <Comments width="100%" href={ArticleStore.article.fb_url} />
                  </AnimateHeightWrapper>
                </CommentsWrapper>
              </ContentHider>
            }
          </ColumnLeft>
          <ColumnRight showModal={showModal}>
            {ArticleStore.article.brid_donation_progress.reqAmount > 0 && (
              <BridDonationProgress
                blockData={ArticleStore.article.brid_donation_progress}
                targetArticleLink={ArticleStore.article.target_article_link}
                partner={ArticleStore.article.brid_partner || undefined} //może być nullem w starszych artykułach
                setShowModal={setShowModal}
                payForm={payForm}
              />
            )}
            <MaskingGradient />
          </ColumnRight>
        </BridArticle>
        {width < 996 && <Adslot name="Brid_rectangle" />}
        <MarginWrapper>
          <BridCompletedProjects
            blockData={ArticleStore.article.brid_other_articles}
          />
        </MarginWrapper>
      </BridBackgroundWrapper>
    </div>

  );
});

const CommentsWrapper = styled("div", {
  margin: "0 auto",
  width: "100%",
  padding: "0px 16px 16px 16px",
  backgroundColor: "$grayscale100",
  color: "$grayscale0",
  "@bp4": {
    padding: "16px 48px",
    "iframe.fb_iframe_widget_lift": {
      width: "100% !important"
    }
  }
});

const ColumnLeft = styled("div", {
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  "@bp4": {
    width: "840px"
  }
});

const StickyWrap = styled("div", {
  variants: {
    "isSticky": {
      true: {
        paddingTop: "180px"
      },
      false: {}
    }
  }
});

const ColumnRight = styled("div", {
  "form": {
    width: "100% !important",
    height: "100%"
  },
  "@bp5": {
    position: "relative",
    height: "inherit",
    width: "408px",
    right: "2%",
    form: {
      width: "100% !important",
      height: "100%"
    }
  },
  "@media (min-width: 1400px)": {
    right: "6%"
  },
  variants: {
    "showModal": {
      true: {
        zIndex: 5000001
      },
      false: {}
    }
  }
});

const MaskingGradient = styled("div", {
  "@bp4": {
    position: "absolute",
    height: "30px",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: 2
  }
});

const BridArticle = styled("div", {
  display: "flex",
  flexDirection: "column-reverse",
  "@bp5": {
    flexDirection: "row"
  }
});

const BridBackgroundWrapper = styled("div", {
  backgroundColor: "#e5e5e5",
  variants:{
    "isDarkTheme":{
      true:{
        backgroundColor: "#131212"
      },
      false: {}
    }
  }
});

const MarginWrapper = styled("div", {
  margin: "0 16px"
});

export default ArticleBrid;
